'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setDictionaries = exports.addDictionary = exports.setLanguages = exports.setCurrentLanguage = undefined;

var _actionTypes = require('./action-types');

var setCurrentLanguage = exports.setCurrentLanguage = function setCurrentLanguage(languageCode) {
    return { type: _actionTypes.SET_CURRENT_LANGUAGE, data: languageCode };
};
var setLanguages = exports.setLanguages = function setLanguages(languageCode) {
    return { type: _actionTypes.SET_LANGUAGES, data: languageCode };
};
var addDictionary = exports.addDictionary = function addDictionary(languageCode, dictionary) {
    return { type: _actionTypes.ADD_DICTIONARY, data: { languageCode: languageCode, dictionary: dictionary } };
};
var setDictionaries = exports.setDictionaries = function setDictionaries(dictionaries) {
    return { type: _actionTypes.SET_DICTIONARIES, data: dictionaries };
};